export function getSummaryName(data: any, type?: 'villaDanji'): string {
  const renderFloorInfo = () => {
    const floorInfo =
      data?.corrpFlrDiv === '2'
        ? data?.floorLevel
        : data?.corrpFlrDiv === '1'
          ? data?.corrpFlr < 0
            ? `B${Math.abs(data.corrpFlr)}`
            : data?.corrpFlr
          : data?.groundFlr < 0
            ? `B${Math.abs(data.groundFlr)}`
            : data?.groundFlr;
    if (data?.underFlr) {
      return `B${data.underFlr}${floorInfo ? ' ~ ' : ''}${floorInfo}층`;
    }
    return floorInfo ? `${floorInfo}층` : '';
  };

  const renderCommonInfo = (addressField: string[]) => {
    return addressField
      .map((field) => {
        if (field === 'dongNm') {
          const dongNm = data?.[field];
          if (!dongNm) return '';
          return dongNm === '명없음' ? '동명없음' : `${dongNm}동`;
        } else if (field === 'addrJibun') {
          return data?.buildingTypeCd === 'D01' ||
            (data?.buildingTypeCd === 'E01' && data?.buildKind === '다가구') ||
            data?.buildingTypeCd === 'E03' ||
            data?.buildingTypeCd === 'G01'
            ? data?.addrJibun === '999-99'
              ? ''
              : data?.addrJibun
            : data?.jibunAddrExpsYn === 'N'
              ? ''
              : data?.addrJibun === '999-99'
                ? ''
                : data?.addrJibun;
        }
        return data?.[field] || '';
      })
      .filter(Boolean)
      .concat(renderFloorInfo())
      .join(' ');
  };

  const summaryNameCheck = () => {
    switch (data?.buildingTypeCd) {
      case 'A01':
      case 'A02':
      case 'A03':
      case 'B01':
      case 'C01':
      case 'C02':
      case 'C03':
        // 아파트, 주상복합, 오피스텔, 재건축, 아파트 분양권, 오피스텔 분양권, 주상복합 분양권
        return renderCommonInfo(['danjiNm', 'dongNm']);

      case 'D01':
        // 빌라/연립
        // 빌라/연립 단지화에 따른 조건 추가
        if (data?.buildNm) {
          if (type === 'villaDanji') {
            return renderCommonInfo(['bjdNm', 'buildNm', 'dongNm']);
          }
          return renderCommonInfo(['buildNm', 'dongNm']);
        }
        return renderCommonInfo(['bjdNm', 'addrJibun']);

      case 'E01':
      case 'E03':
        // 단독/다가구, 상가주택
        return data?.businessDiv === 'S'
          ? renderCommonInfo(['bjdNm', 'addrJibun'])
          : renderCommonInfo(['bjdNm', 'addrJibun']);

      case 'E02':
        // 전원/농가 주택
        return [
          data?.bjdNm,
          data?.jibunAddrExpsYn === 'N' ? '' : data?.addrJibun || '',
          data?.groundFlr
            ? data.groundFlr < 0
              ? `B${Math.abs(data.groundFlr)}층`
              : `${data.groundFlr}층`
            : '',
        ]
          .filter(Boolean)
          .join(' ');

      case 'E04':
        // 한옥주택
        return renderCommonInfo(['bjdNm', 'addrJibun']);

      case 'G01':
        // 원룸
        return renderCommonInfo(['bjdNm', 'addrJibun']);

      case 'K01':
        // 재개발
        return data?.danjiNm || '';

      default:
        return '';
    }
  };

  return summaryNameCheck();
}

export default function SummaryName({ data }: { data: any }) {
  return (
    <div className="dot_divide">
      <p>{getSummaryName(data)}</p>
    </div>
  );
}
